import(/* webpackMode: "eager" */ "/github/workspace/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/github/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/src/components/analytics/GoogleTagManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/src/components/analytics/GoogleTagManagerNoScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/src/components/analytics/TermlyCMP.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/src/components/analytics/XConversionTracking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/src/components/i18n/TranslationsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/src/components/ui/footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/src/components/ui/header/ConditionalHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/src/components/ui/IntercomProvider.tsx");
